import { AuthenticatedRoute } from "@/routes/_authenticated";

/**
 * Returns the authenticated user and session from the _authenticated route
 * context. This is the single source of truth for auth state in components.
 *
 * Only call this from components rendered inside the /_authenticated layout.
 * The user and session are guaranteed to be defined — the route guard in
 * _authenticated.tsx redirects to /login before any child renders if there
 * is no valid session.
 */

export function useAuth() {
  return AuthenticatedRoute.useRouteContext();
}
